import HomeIcon from '../../../assets/svg/home_icon.svg'
import MailIcon from '../../../assets/svg/mail_icon.svg'
import ModoAccesible from '../../../assets/svg/modo_accesible.svg'
import TepjfLogo from '../../../assets/svg/tepjf_logo.svg'
import TwitterIcon from '../../../assets/svg/x.svg'
import FacebookIcon from '../../../assets/svg/facebook_icon.svg'
import TikTokIcon from '../../../assets/svg/tiktok.svg'
import YoutubeIcon from '../../../assets/svg/youtube_icon.svg'
import EncuestaIcon from '../../../assets/img/encuesta.png'

export default function Header() {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center" role='navigation' aria-label='transparencia header'>
        <div className="col-md-12 header_container_main d-flex justify-content-between align-items-center px-3">
          <div className="icons_socialmedia text-end ps-md-0">
            <a href="" role='link' aria-label='regresar a página principal'>
              <img className="ms-1 mt-1 mt-md-0" src={HomeIcon} alt="home" />
            </a>
            <a
              role='link'
              href="mailto:contactoweb@te.gob.mx?Subject=Contacto%20TEPJF"
              aria-label="Correo contacto web"
              style={{ textDecoration: "none" }}
              title="se abrirá aplicación de correo">
              <img className="mx-1 mt-1 mt-md-0" src={MailIcon} alt="email" />
            </a>
            <a
              role='link'
              aria-label='ir a inclusión'
              href="https://te.inklusion.incluirt.com/transparencia-home/"
              className=""
              target='_blank'>
              <img className="mt-1 mt-md-0 icon_modo_accesible" src={ModoAccesible} alt="modo accesible" />
            </a>
          </div>
          <a
            role='link'
            aria-label='ir a tribunal electoral del poder judicial de la federación'
            href="https://www.te.gob.mx/"
            className="d-flex align-items-center ps-3 ps-md-0 content_tepjf_logo"
            target='_blank'>
            <img src={TepjfLogo} className="tepjf_logo img-fluid" alt="tribunal electoral del poder judicial de la federación" />
          </a>

          <div className="icons_socialmedia text-end ps-md-0 d-flex align-items-center">
            <a
              role='link'
              aria-label='ir a Encuesta de satisfacción'
              href="https://www.te.gob.mx/transparencia/front/encuesta/index?text==Ng=="
              target='_blank'>
              <img className="me-2" src={EncuestaIcon} alt="Encuesta de satisfacción" />
            </a>
            <a
              role='link'
              aria-label='ir a twitter'
              href="https://twitter.com/TEPJF_informa"
              target='_blank'>
              <img className="me-2" src={TwitterIcon} alt="twitter" />
            </a>
            <a
              role='link'
              aria-label='ir a tik tok'
              href="https://www.tiktok.com/@tepjf_informa?_t=8gycvBZBh6j&_r=1"
              target='_blank'>
              <img className="me-2" src={TikTokIcon} alt="tik tok" />
            </a>

            <a
              role='link'
              aria-label='ir a facebook'
              href="https://www.facebook.com/TEPJF"
              target='_blank'>
              <img className="me-2" src={FacebookIcon} alt="facebook" />
            </a>
            {/* <a href="">
              <img className="me-2" src={InstagramIcon} alt="instagram" />
            </a> */}
            <a
              role='link'
              aria-label='ir a youtube'
              href="https://www.youtube.com/user/TEPJF"
              target='_blank'>
              <img className="" src={YoutubeIcon} alt="youtube" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
